module.exports = __webpack_public_path__ + "static/img/cd-icon.55adfd6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/fonts/cd-icon.svg?t=1515049352921
// module id = 765
// module chunks = 11